import { getLoggedInUserId } from 'selectors/loggedInUser';

/**
 * This branch of the reducer is used entirely for saving
 * URLSearchParam query strings for parts of the UI that need to remember their
 * filter values and maintain some stickiness between sessions
 *
 * - Uses our pattern for syncing the state of this reducer with localStorage
 */
export const SAVE_VALUE = 'SAVE_SEARCH';

export const saveItem = ({ key, value, scope = 'global' }) => ({
  type: SAVE_VALUE,
  payload: { key, value, scope },
});

export const saveUserItem = ({ key, value }) => {
  return (dispatch, getState) => {
    const currentState = getState();
    const currentUuid = getLoggedInUserId(currentState);
    dispatch(saveItem({ key, value, scope: currentUuid }));
  };
};
